import { ConfigActions } from "@redux/reducer";
import store from "@redux/store";
import { FeaturesType, TagCategoriesType } from "@type/index";

export const executeOnceAtATime = (fn: any) => {
  let isSagaExecuting = false;
  return function* (...rest: any) {
    if (!isSagaExecuting) {
      isSagaExecuting = true;
      yield* fn(...rest);
      isSagaExecuting = false;
    }
  };
};

const validateQueryParam = (
  paramName: string, // Url parameter name (such as "featureId" or "coordinate")
  getFilteredList: (arr: string[]) => string[]
) => {
  const {
    urlParams: urlSearchValue,
    globalCounter,
    urlTotalParams,
    urlChange
  } = store.getState().config;
  const urlParams = new URLSearchParams(urlSearchValue);

  // Check whether the parameter exists
  if (urlParams.has(paramName) && window.location.search) {
    let hasChange = false;
    // Counter to determine whether all parameters have been validated
    const count = globalCounter + 1;
    store.dispatch(ConfigActions.setGlobalCounter(count));

    const paramValue = urlParams.get(paramName);
    const paramArray = paramValue ? paramValue.split(",") : [];

    // Filter out values that do not exist in the list
    const filteredArray = getFilteredList(paramArray);

    // If the filtered array is different from the original array, there are missing values
    if (filteredArray.length !== paramArray.length) {
      // If the filtered array is empty, delete this parameter
      if (filteredArray.length === 0) {
        urlParams.delete(paramName);
      } else {
        // Update the value of this parameter
        urlParams.set(paramName, filteredArray.join(","));
      }
      store.dispatch(ConfigActions.setUrlParams(urlParams.toString()));
      store.dispatch(ConfigActions.setUrlChange(true));
      hasChange = true;
    }

    if (count === urlTotalParams && (urlChange || hasChange)) {
      // Rebuild the new URL (replace only the current parameters)
      const newUrl = `${window.location.origin + window.location.pathname}${
        urlParams.toString()
          ? `?${decodeURIComponent(urlParams.toString())}`
          : ""
      }`;
      // Refresh the page
      window.location.href = newUrl;
    }
  }
};

// Check feature
export const checkFeatureCode = (featureList: Array<FeaturesType>) => {
  validateQueryParam("featureId", (arr: string[]) =>
    arr.filter((item: string) =>
      featureList.some((obj: FeaturesType) => obj.id === item)
    )
  );
};

// Check coordinate
export const checkCoordinate = (coordinateList: Array<TagCategoriesType>) => {
  validateQueryParam("coordinate", (arr: string[]) =>
    arr.filter((item: string) =>
      coordinateList.some((obj: TagCategoriesType) => obj.code === item)
    )
  );
};
